import './wordcloud_widget_view.js.coffee'

Namespace 'Monitoring.Views.Charts'

class Monitoring.Views.Charts.WordsCloudChartView extends Monitoring.Views.Charts.WordcloudWidgetView

  jobName: 'words'

  initialize: (@options={}) ->
    super($.extend(@options, {
      title: I18n.t('monitoring.dashboard.charts.ranking.cloud.title')
    }))

  metricsSpecification: ->
    [
      {
        name: I18n.t('monitoring.dashboard.charts.ranking.cloud.contents'),
        key: 'count'
      },
      {
        name: I18n.t('monitoring.dashboard.charts.ranking.cloud.unique_users'),
        key: 'unique_users_count'
      }
    ]
